// extracted by mini-css-extract-plugin
export default {"orDivider":"OrDivider--orDivider--1hf5c","or":"OrDivider--or--scsGp","light":"OrDivider--light--1XgjF","line":"OrDivider--line--XO1qL"};